import fetcher from './fetchers'

// 作者基本信息
export const fetchInfo = (params) => {
  return fetcher.post('/v1/ugc/author/detail', params)
}

// 作者上传的壁纸
export const fetchWorks = (params) => {
  return fetcher.post('/v1/ugc/author/works', params)
}

// 动态壁纸详情
export const fetchDynamicDetail = (params) => {
  return fetcher.post('/wallpaper/live/detail', params)
}
